import React, { Component } from "react";
import { CardBody, Card, Label, Col, Button, Row } from "reactstrap";
import './style.css'
import { Preloading } from '../../components/UI/Preloader/action';
import { connect } from "react-redux";
import { addIfscMasterUpload, ifscMasterTemplateRequest, ifscMasterDataExcelRequest, ifscMasterListRequest  } from "./action";
import { toast } from 'react-toastify';
import fileSaver from 'file-saver';
import { DEFAULT_PAGE_SIZE,DEFAULT_PAGE_NUMBER } from "../IfscMaster/IfscMasterTable/constants";

import IfscMasterListFilterFrom from "./IfscMasterFilter/index";

import  IfscMasterTable   from "./IfscMasterTable/index";
import {buildIfscMasterFetchRequest} from "./helper";

class IfscMasterUploadUtility extends Component {
  constructor(props) {
    super(props);
    this.state = {
      type: "",
      ifscMasterExcelFile: '',
      noExcelUploadWarning: '',
      pageSize: this.props.defaultPageSize || DEFAULT_PAGE_SIZE,
      pageNumber: DEFAULT_PAGE_NUMBER,
      currentFilter: {},
      sorted: [{
        id: "createdAt",
        desc: true
      }]
    };
  }

  componentDidUpdate(prevProps) {

    if (this.props.ifscMasterTemplateSuccess !== prevProps.ifscMasterTemplateSuccess) {
      this.props.preloading(false)
      var blob = new Blob([this.props.ifscMasterTemplateSuccess.data], { type: 'application/octet-stream' });
      fileSaver.saveAs(blob, `ifscMasterExcelFile.xlsx`);
      toast.success(
        <div>
          <i className="fa fa-check-circle fa-lg"></i>&nbsp;File Downloaded Successfully
        </div>
      );
    }
    if (this.props.ifscMasterTemplateFailure !== prevProps.ifscMasterTemplateFailure) {
      this.props.preloading(false)
      toast.error(
        <div>
          <i className="fa fa-exclamation-triangle"></i>&nbsp;Some error occured<br />&nbsp;Please try again!
        </div>
      );
    }

    if (this.props.ifscMasterDataExcelSuccess !== prevProps.ifscMasterDataExcelSuccess) {
      this.props.preloading(false)
      var blob = new Blob([this.props.ifscMasterDataExcelSuccess.data], { type: 'application/octet-stream' });
      fileSaver.saveAs(blob, `Ifsc_Master_Data.xlsx`);
      toast.success(
        <div>
          <i className="fa fa-check-circle fa-lg"></i>&nbsp;File Downloaded Successfully
        </div>
      );
    }
    if (this.props.ifscMasterDataExcelFailure !== prevProps.ifscMasterDataExcelFailure) {
      this.props.preloading(false)
      toast.error(
        <div>
          <i className="fa fa-exclamation-triangle"></i>&nbsp;Some error occured<br />&nbsp;Please try again!
        </div>
      );
    }

    if (this.props.addIfscMasterUploadSuccess !== prevProps.addIfscMasterUploadSuccess) {
      this.props.preloading(false)
      toast.success(
        <div>
          <i className="fa fa-check-circle fa-lg"></i>&nbsp; {this.props.addIfscMasterUploadSuccess.data}
        </div>
      );
      setTimeout(() => {
        window.location.reload();
    }, 1500);
    }
    if (this.props.addIfscMasterUploadFailure !== prevProps.addIfscMasterUploadFailure) {
      this.props.preloading(false)
      toast.error(
        <div>
          <i className="fa fa-check-circle fa-lg"></i>&nbsp; {this.props.addIfscMasterUploadFailure.data.data}
        </div>
      );
    }
  }

openFilter = () => {
  this.setState({ showFilter: true });
};

closeFilter = () => {
  this.setState({ showFilter: false });
};

onSortedChange = (sorted) =>{
  this.setState({
    sorted: sorted[0],
    pageNumber: DEFAULT_PAGE_NUMBER
  },()=>{
    this.fetchIfscmasterList();
  })
}

fetchIfscmasterList = () =>{
  const {pageNumber, pageSize, currentFilter, sorted } = this.state;
  const requestBody = buildIfscMasterFetchRequest({pageNumber,pageSize, filter: currentFilter , sorted});
  this.props.ifscMasterListRequest(requestBody);
};

componentDidMount(){
  this.fetchIfscmasterList();
}

handleApplyFilter = (filter) => {
  this.setState({
    showFilter: false,
    currentFilter: filter,
    pageNumber: DEFAULT_PAGE_NUMBER

  },()=>{
    this.fetchIfscmasterList();
  });

};

onPageChange = (pageIndex) =>{
  this.setState({
    pageNumber: pageIndex
  },()=>{
    this.fetchIfscmasterList();
  });
};

onPageSizeChange = (pageSize) =>{
  this.setState({
    pageSize,
    pageNumber: DEFAULT_PAGE_NUMBER
  },()=>{
    this.fetchIfscmasterList();
  });
};

  handleTemplateDownload = () => {
    this.props.preloading(true)
    this.props.ifscMasterTemplateRequest();
  }

  handleDownloadIfscData = () => {
    this.props.preloading(true)
    this.props.ifscMasterDataExcelRequest();
  }

  uploadExcel = (event) => {
    this.setState({
      ifscMasterExcelFile: event.target.files[0]
    })
    event.preventDefault();
    event.target.value = null;
  }

  handleSubmit = () => {
    if (!this.state.ifscMasterExcelFile) {
      this.setState({ noExcelUploadWarning: '*Please upload the filled request template!' })
    }
    if (this.state.type === '') {
      toast.error(
        <div>
          <i className="fa fa-exclamation-triangle"></i>&nbsp;Please Select Upload Type
        </div>
      );
    }

    else {
      this.props.addIfscMasterUpload({ file: this.state.ifscMasterExcelFile, type: this.state.type });
      this.props.preloading(true);
    }
  }

  render() {
    const paginatedData = this.props.ifscMasterViewPaginatedList || {};
    const data = paginatedData.content || [];
    const pagination = paginatedData.pageable || {};
    const totalPages = paginatedData.totalPages || 0;
    return (
      <Col>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h4 className="mb-0 text-center">IFSC Master Upload</h4>
        </div>
        <Card>
          <CardBody>
            <Label>Upload IFSC Master Template</Label>
            <Row>
              <Col sm="22">
                <Button
                  color="primary"
                  onClick={this.handleTemplateDownload}
                  className="btn color-excel-download "
                >
                  <i className="fa fa-file-excel-o fa-lg"></i>
                  &nbsp;&nbsp;Download Template
                </Button>
                <Row
                  color="primary"
                  className="btn btn-primary ml-0 position-relative excel-upload-btn browse-files ml-3"
                  title="Upload Request Template"
                >
                  <input
                    onChange={this.uploadExcel}
                    type="file"
                    name="file"
                    id="file"
                    className="upload-file"
                    title="Upload Request Template"
                    accept=".xlsx"
                  />
                  <i className="fa fa-paperclip color-888 rotate-90deg p-1 fa-lg" />{" "}
                  Upload Template
                </Row>
                <Label className="uploadType">Upload Type : </Label>
                <div className="ifscType">
                  <input name="type" type="radio" value="add" onChange={e => { this.setState({ type: e.target.value }) }} />
                  &nbsp;&nbsp;Add New Records
                  <label>
                    <input name="type" type="radio" value="edit" onChange={e => { this.setState({ type: e.target.value }) }} />
                    &nbsp;&nbsp;Update Existing
                  </label>
                </div>
                <Button
                  className="ml-5"
                  color="primary"
                  onClick={this.handleSubmit}
                >
                  Submit
                </Button>
                <Button className="ml-5"
                  color="success" onClick={this.handleDownloadIfscData}>Download Existing Data</Button>
                    <Button className="ml-2" color="primary" onClick={this.openFilter}>
                  <i className="fa fa-filter fa-lg"></i> Apply Filters  
                </Button>
                <Row className={(this.state.ifscMasterExcelFile) ? "text-muted ml-1 transaction-file-name-text" : "text-danger ml-1 noUploadWarning-text"}>{(this.state.ifscMasterExcelFile) ? this.state.ifscMasterExcelFile.name : this.state.noExcelUploadWarning}</Row>
              </Col>
            </Row>
          </CardBody>
        </Card>

        <IfscMasterListFilterFrom
        isOpen = {this.state.showFilter}
        toggle={this.closeFilter}
        onApply={this.handleApplyFilter}

        
        />

        <IfscMasterTable
        paginatedResponse={this.props.ifscMasterViewPaginatedList}
        loading={this.props.loading}
        pageSize={this.state.pageSize}
        pageNumber={this.state.pageNumber}
        onPageChange={this.onPageChange}
        onPageSizeChange={this.onPageSizeChange}
        sorted={this.state.sorted}
        onSortedChange={this.onSortedChange}
        
        />
      </Col>
    );
  }
}



const mapStateToProps = (state, ownProps) => ({
  ifscMasterTemplateSuccess: state.ifscMasterReducer.ifscMasterTemplateSuccess,
  ifscMasterTemplateFailure: state.ifscMasterReducer.ifscMasterTemplateFailure,
  addIfscMasterUploadSuccess: state.ifscMasterReducer.addIfscMasterUploadSuccess,
  addIfscMasterUploadFailure: state.ifscMasterReducer.addIfscMasterUploadFailure,
  ifscMasterDataExcelSuccess: state.ifscMasterReducer.ifscMasterDataExcelSuccess,
  ifscMasterDataExcelFailure: state.ifscMasterReducer.ifscMasterDataExcelFailure,
  ifscMasterViewPaginatedList: state.ifscMasterReducer.ifscMasterListSuccess,
})

const mapDispatchToProps = (dispatch, ownProps) => ({
  preloading: (isPreloading) => { dispatch(Preloading(isPreloading)); },
  ifscMasterTemplateRequest: () => dispatch(ifscMasterTemplateRequest()),
  ifscMasterDataExcelRequest: () => dispatch(ifscMasterDataExcelRequest()),
  addIfscMasterUpload: (data) => dispatch(addIfscMasterUpload(data)),
  ifscMasterListRequest: (data)=>dispatch(ifscMasterListRequest(data)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IfscMasterUploadUtility);